import classNames from 'classnames';

interface TagProps extends React.PropsWithChildren {
  variant?: 'primary' | 'success' | 'warning' | 'danger' | 'neutral';
  className?: string;
}

function Tag({ variant = 'neutral', className, children }: TagProps) {
  return (
    <div
      className={classNames(
        'inline-block rounded-md px-2 py-1 font-semibold',
        variant === 'primary' && 'bg-blue-200 text-black',
        variant === 'success' && 'bg-green-200 text-black',
        variant === 'warning' && 'bg-yellow-300 text-black',
        variant === 'danger' && 'bg-red-300 text-black',
        variant === 'neutral' && 'bg-neutral-200 text-black',
        className
      )}
    >
      {children}
    </div>
  );
}

export default Tag;
